module.exports = __webpack_public_path__ + "static/banner-4-concert-performance-b4a427ffe084b4ec52f25c13996bf5a6.jpg";